import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home'
import Login from 'views/login'

import NotFound from 'views/errPages/NotFound.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/',
    name: 'home',
    redirect: '/welcome',
    component: Home,
    children: [
      {
        path: '/welcome',
        name: 'welcome',
        component: () => import('views/home/welcome')
      }
    ]
  }, {
    path: '/publicity',
    name: 'publicity',
    component: () => import('views/publicity')
  }, {
    path: '*',
    name: '404',
    component: NotFound
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {

  const { loginInfo } = store.state;

  // if (to.path == '/login' || to.path == '/publicity') next()

  // path == '' 和 path == '/' 是不一样的
  // const loginPath = isPC() ? '/login' : '/e-login'

  if (loginInfo.userName == undefined && to.path == '/welcome') {
    // 这样可以使用户选择去e-login还是login,还可以保证没登录就进不来系统
    return next('/login')
  }

  next()
})

export default router
